/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapid_Eager_Otter_RenewInputs */

const fr_rapid_eager_otter_renew = /** @type {(inputs: Rapid_Eager_Otter_RenewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réactiver votre abonnement`)
};

/**

* @param {Rapid_Eager_Otter_RenewInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const rapid_eager_otter_renew = /** @type {((inputs?: Rapid_Eager_Otter_RenewInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapid_Eager_Otter_RenewInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_rapid_eager_otter_renew(inputs)
});